import ContactForm from '../components/ContactForm'
import MessageList from '../components/MessageList'
import Navigation from '../components/Navigation'

export default function Welcome() {
  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      <main className="container mx-auto px-4 py-16">
        <div className="text-center space-y-6 mb-16">
          <h1 className="text-4xl font-bold tracking-tight">Welcome to Starter Kit</h1>
          <p className="text-muted-foreground max-w-[600px] mx-auto">
            A modern starter template with shadcn/ui components, built for Cloudflare Pages
          </p>
          <p className="text-sm text-white/60">
            Public Key: <span className="font-mono bg-white/10 px-2 py-1 rounded">{import.meta.env.VITE_SOME_PUBLIC_KEY}</span>
          </p>
        </div>
        <ContactForm />
        <MessageList />
      </main>
    </div>
  )
}